<div class="component-container">
<div class="container">
        

        <div class="verification-card">
            <div class="success-message" id="successMessage">
                Verification email sent! Please check your inbox.
            </div>

            <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            </div>

            <h1>Verify Your Email Address</h1>
            <p class="description">
                We've sent a verification email to your address. Please check your inbox and click on the verification link to continue.
            </p>

            <div class="email-display" id="userEmail">
                {{ hashedEmail?.email }}
            </div>

            <button class="btn btn-primary" id="resendButton" [disabled]="emailSent" (click)="resendEmailVerification()">Resend Verification Email</button>
            <div class="timer" id="resendTimer" style="display: none;">
                You can request another email in <span id="countdown">60</span> seconds
            </div>

            <p style="margin-top: 1.5rem;">
                <button class="btn btn-link" id="changeEmailButton" [routerLink]="['/update-email']">Change Email Address</button>
            </p>
        </div>

        <div class="tips">
            <h3>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Tips
            </h3>
            <ul>
                <li>If you don't see the email in your inbox, check your spam or junk folder.</li>
                <li>The verification link will expire in 24 hours.</li>
                <li>Make sure your email address was entered correctly.</li>
                <li>Still having trouble? Contact our <a [routerLink]="['/contact']" style="color: var(--accent);">support team</a>.</li>
            </ul>
        </div>

        <div class="footer">
            <p>Already verified? <a [routerLink]="['/login']">Back to Login</a></p>
        </div>
    </div>
</div>
